module.exports = __webpack_public_path__ + "img/unitel_header.3612aeec.png";